import { Box, Typography } from '@material-ui/core';
import { Observer } from 'mobx-react';
import React from 'react';
import { DocumentRevisionFooterProps } from '../../../../..';
import { translate } from '../../../../../../common/intl';
import { MomentFormats, useDate } from '../../../../../../common/utils/date';
import { styles } from './DocumentRevisionFooter.new.styles';
import { withDocumentRevisionFooterWrap } from './DocumentRevisionFooter.wrap';

const DocumentRevisionFooterNew: React.FunctionComponent<DocumentRevisionFooterProps> = ({
  _documentRevisionFooterState,
}) => {
  const classes = styles();
  const { getFormattedDateString } = useDate();

  return (
    <Observer>
      {() => (
        <Box
          pt={2.5}
          display={_documentRevisionFooterState?.hidden ? 'none' : 'block'}
        >
          <Typography className={classes.releaseDate}>
            <span data-cy="output.info">{translate('output.info')}</span>
          </Typography>
          <Typography component="div" className={classes.released}>
            {_documentRevisionFooterState?.docId},&nbsp;
            <span data-cy="common.revision">{translate('common.revision')}</span> {_documentRevisionFooterState?.version}, &nbsp;
            {getFormattedDateString(
              _documentRevisionFooterState?.releasedAt,
              MomentFormats.MonthDateYearTwoDigit,
            )}
          </Typography>
        </Box>
      )}
    </Observer>
  );
};

export default withDocumentRevisionFooterWrap(DocumentRevisionFooterNew);
